'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash.omit');

var _lodash2 = _interopRequireDefault(_lodash);

var _reactackleCore = require('reactackle-core');

var _Tab = require('./Tab');

var _DefaultLinkComponent = require('./Link/DefaultLinkComponent');

var _TabsWrapperStyled = require('./styles/TabsWrapperStyled');

var _TabsListStyled = require('./styles/TabsListStyled');

var _TabsContentWrapperStyled = require('./styles/TabsContentWrapperStyled');

var _theme = require('./styles/theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

(0, _reactackleCore.registerDefaultComponentTheme)('tabs', _theme2.default);

var propTypes = {
  /**
    * Props that will be passed to Tab Item
    * @customType Tab.PropTypes
    */
  tabs: _propTypes2.default.arrayOf(_propTypes2.default.shape((0, _lodash2.default)(_Tab.Tab.propTypes, ['colorScheme', 'index', 'isSelected', 'onSelect']))),
  /**
   * Specify selected tab by number
   */
  selected: _propTypes2.default.number,
  /**
   * Specify color scheme
   */
  colorScheme: _propTypes2.default.oneOf(['light', 'dark']),
  /**
   * Specify link component that will be used in Tab
   */
  linkComponent: _propTypes2.default.func,
  /**
   * Specify function that will be called on selected Tab change
   */
  onChange: _propTypes2.default.func
};

var defaultProps = {
  tabs: [],
  selected: 0,
  colorScheme: 'dark',
  linkComponent: _DefaultLinkComponent.DefaultLinkComponent,
  onChange: _reactackleCore.noop
};

var Tabs = function (_Component) {
  _inherits(Tabs, _Component);

  function Tabs(props) {
    _classCallCheck(this, Tabs);

    var _this = _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, props));

    _this.state = {
      selected: props.selected
    };

    _this._handleTabSelection = _this._handleTabSelection.bind(_this);
    return _this;
  }

  _createClass(Tabs, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (props.selected !== this.state.selected) this.setState({ selected: props.selected });
    }
  }, {
    key: '_handleTabSelection',
    value: function _handleTabSelection(_ref) {
      var index = _ref.index;

      this.setState({
        selected: index
      });

      this.props.onChange({
        value: index
      });
    }
  }, {
    key: '_renderTabs',
    value: function _renderTabs() {
      var _this2 = this;

      var selected = this.state.selected;


      return this.props.tabs.map(function (tab, key) {
        var index = (0, _reactackleCore.getKey)(tab, key);
        var tabProps = _extends({}, tab, {
          index: index,
          colorScheme: _this2.props.colorScheme,
          onSelect: _this2._handleTabSelection,
          isSelected: index === selected,
          linkComponent: tab.linkComponent || _this2.props.linkComponent
        });

        return _react2.default.createElement(_Tab.Tab, _extends({}, tabProps, { key: index }));
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var tabs = this._renderTabs();

      return _react2.default.createElement(
        _TabsWrapperStyled.TabsWrapperStyled,
        { colorScheme: this.props.colorScheme },
        _react2.default.createElement(
          _TabsContentWrapperStyled.TabsContentWrapperStyled,
          null,
          _react2.default.createElement(
            _TabsListStyled.TabsListStyled,
            null,
            tabs
          )
        )
      );
    }
  }]);

  return Tabs;
}(_react.Component);

exports.default = Tabs;


Tabs.propTypes = propTypes;
Tabs.defaultProps = defaultProps;
Tabs.displayName = 'Tabs';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-tabs/dist/Tabs.js
// module id = 821
// module chunks = 0